function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';
import { ProductForm } from '@shopify/theme-product-form';
import { cart, product } from 'scripts/helpers/iamota-shopify-ajax';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import registerCustomElement from 'scripts/helpers/register-custom-element';
import translate from 'scripts/helpers/iamota-translate';

// Styles
import './_card.scss';

// -------------------------------------
// Web Component
// -------------------------------------
class iamProductCardForm extends HTMLElement {
  constructor() {
    var _this$dataset, _this$dataset2, _this$dataset3;
    super();

    // Variables
    this.productData = null;
    this.customData = null;
    this.sectionId = (_this$dataset = this.dataset) === null || _this$dataset === void 0 ? void 0 : _this$dataset.sectionId;
    this.productHandle = (_this$dataset2 = this.dataset) === null || _this$dataset2 === void 0 ? void 0 : _this$dataset2.productHandle;
    this.productId = (_this$dataset3 = this.dataset) === null || _this$dataset3 === void 0 ? void 0 : _this$dataset3.productId;
    this.variantIdInput = this.querySelector('input[name="id"]');
    this.form = this.querySelector('form');

    // Initalize ProductForm
    var productFetchPromise = product.fetch(this.productHandle).then(productData => {
      this.productData = productData;
      this.ProductForm = new ProductForm(this.form, this.productData, {
        onFormSubmit: this.onFormSubmit.bind(this)
      });
    });
    console.log("iamProductCardForm connected: sectionId=".concat(this.sectionId, ", productHandle=").concat(this.productHandle, ", productId=").concat(this.productId));
  }

  /**
   * Handle form submission
   * @param {*} event
   * @returns
   */
  onFormSubmit(event) {
    var _this = this;
    return _asyncToGenerator(function* () {
      // Block the native form submission behavior
      event.preventDefault();

      // // Block submitting the form in an invalid state
      // if (!await this.validateForm()) {
      //     this.setErrorState(translate('Unable to submit the form with errors', 'productForm.error_validation'));
      //     return;
      // }

      // Standardize Form data as an object
      // let formData = iamotaAjax.formToObject(this);
      var formData = new FormData(_this.form);
      formData = Object.fromEntries(formData.entries());

      // Allow form data to be modified before submission
      formData = yield iamotaEventHandler.applyFilters('productForm:submitting:data', formData, _objectSpread(_objectSpread({
        iamProductForm: _this
      }, event.dataset), {}, {
        event
      }));

      // Submit the form over AJAX
      iamotaEventHandler.trigger('productForm:submitting', {
        iamProductForm: _this,
        formData,
        event
      }, {
        context: _this
      });
      cart.add(formData).then(responseData => {
        iamotaEventHandler.trigger('productForm:submitted:success', {
          iamProductForm: _this,
          cart: responseData
        }, {
          context: _this
        });
      }).catch(error => {
        var _error$context;
        iamotaEventHandler.trigger('productForm:submitted:error', {
          iamProductForm: _this,
          error
        }, {
          context: _this
        });
        console.error(error);
        if ((_error$context = error.context) !== null && _error$context !== void 0 && (_error$context = _error$context.data) !== null && _error$context !== void 0 && _error$context.description) {
          _this.setErrorState(error.context.data.description);
        } else {
          _this.setErrorState(translate('Error adding item to cart', 'productForm.error_adding'));
        }
      });
    })();
  }
}
registerCustomElement('iam-product-card-form', iamProductCardForm);